export function ShiftTradeSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/shift-trade.svg'"></ng-include>`
    }
}
            